import { Select, Switch } from 'antd'
import { usePointCloudContext } from 'features/pointClouds'
import { PointColorType } from 'gecko-potree-core'
import {
  ControlItem,
  ControlLabel,
} from 'pages/pointClouds/components/hud/controlPanel/ControlPanel.styles'
import React from 'react'

export const ColorControls: React.FC = () => {
  const {
    enableEdl,
    setEnableEdl,
    colorMode,
    setColorMode,
    enableWhitePoints,
    setEnableWhitePoints,
  } = usePointCloudContext()

  return (
    <>
      <ControlItem>
        <ControlLabel>Calculate Outlines</ControlLabel>
        <Switch checked={enableEdl} onChange={setEnableEdl} />
      </ControlItem>
      <ControlItem>
        <ControlLabel>Turn Black Points White</ControlLabel>
        <Switch checked={enableWhitePoints} onChange={setEnableWhitePoints} />
      </ControlItem>
      <ControlItem>
        <ControlLabel>Color Mode</ControlLabel>
        <Select
          style={{ minWidth: '150px' }}
          popupMatchSelectWidth={false}
          options={[
            { label: 'RGB', value: PointColorType.RGB },
            { label: 'RGB Height', value: PointColorType.RGB_HEIGHT },
            { label: 'Height', value: PointColorType.HEIGHT },
            { label: 'Filtered Hue', value: PointColorType.FILTERED_HUE },
            { label: 'Debug LOD', value: PointColorType.DEBUG_LOD },
            { label: 'Normal', value: PointColorType.NORMAL },
          ]}
          value={colorMode}
          onChange={(value) => setColorMode(value)}
        />
      </ControlItem>
    </>
  )
}
